import React, { Fragment, useMemo } from 'react'
import { Icon } from '@iconify/react'
import SectionCard from '../../shared/SectionCard'
import './style.css'
import { Image } from '@/components/crRender'
import medicalPlaceholder from '@/assets/images/placeholders/medical-placeholder.webp'


const APLINK = window.API_URL

const BasicInformation = ({ requestDetails }) => {

    const logo = useMemo(() => {
        let Imgs = requestDetails?.files?.findFirstValue('name', 'logo')?.data || []
        return !!Imgs?.length ? Imgs[Imgs?.length - 1 || 0]?.name : ""
    }, [requestDetails])



    return (
        <SectionCard icon="mdi:hospital-building" titleKey="basic-information">
            <div className="basic-info-content">
                <div className="hospital-image-wrapper">
                    <Image src={`${APLINK}${logo}`} className="hospital-main-image" placeholder={medicalPlaceholder} />
                </div>

                <div className="hospital-basic-details">
                    <div className="hospital-name-section">
                        <div className="hospital-name-badge">
                            <Icon icon="mdi:hospital-building" className="hospital-name-icon" />
                            <h3 className="hospital-name-text">
                                {requestDetails?.providerName}
                            </h3>
                        </div>
                    </div>
                    <div className="d-flex location-items-container">
                        <div className="hospital-location-item">
                            <Icon icon="proicons:location" className="hospital-location-icon" />
                            <span className="hospital-location-text">{requestDetails?.mainAddress}</span>
                        </div>
                        {requestDetails?.locations?.slice(0, 4).mapWithKey((location, index) => (
                            <Fragment key={location.key} >
                                <div className="hospital-location-item">
                                    <Icon icon="lsicon:earth-outline" className="hospital-location-icon" />
                                    <span className="hospital-location-text">{location.value}</span>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                    <div className="hospital-description">
                        <p>{requestDetails?.profileSummary}</p>
                    </div>


                </div>
            </div>
        </SectionCard>
    )
}

export default BasicInformation

